import { DepositStore } from "@state/stores/payment/deposit";
import { createContext } from "react";

//@ts-expect-error
export const DepositContext = createContext<DepositStore>(null);
